import { PaginationResponse, PagedStatsResponse } from "../../Shared/Pagination/PaginationResponse";
import { getApi, getApiById, getApiListById, postApi, postApiPagination, putApi } from "../../Shared/Services/RestService";
import { AllInvitationByInvitedUserRequestDTO, AllInvitationByInvitedUserResponseDTO, CandidateInvitationStats, CandidateProfile, CandidateTotalCountResponse, InvitationStats } from "../Types/CandidateType";


export const getAllCandidates = (page: number =0 ,size?: number) => {
  const params: any = {
    page,
  };    

  // Only send size if provided
  if (size !== undefined) {
    params.size = size;
  }
  return getApi<PaginationResponse<CandidateProfile>>("/candidates", params);
};

export const getCandidateById = (id: string ) => {
  return getApiById<CandidateProfile | null>("/candidates/user", id);
};

/**
 * Looks a candidate up by its own primary key.
 *
 * <p>{@link getCandidateById} is named the same way but resolves
 * `GET /candidates/user/{userId}`, so passing it a candidate id silently looks
 * up the wrong record. Anything that starts from a database row - the data
 * service record view, for instance - has the candidate id and must use this.</p>
 */
export const getCandidateProfileById = (id: string) => {
  return getApiById<CandidateProfile | null>("/candidates", id);
};

export const createUser = (payload: any) => {
  return postApi<CandidateProfile>("/candidates", payload);
};

export const updateCandidate = (payload: any, id: string) => {
  return putApi<CandidateProfile | null>("/candidates", id, payload);
};


export const getInvitationStatsByCandidiateId = (id: string ) => {
  return getApiById<CandidateInvitationStats | null>("/invitations/count", id);
};


export const getAllInvitationsByInvitedUser = (id: string, page: number =0 ,size?: number  ) => {
  const params: any = {
    page,
  };    

  // Only send size if provided
  if (size !== undefined) {
    params.size = size;
  }
  return getApiListById<PaginationResponse<AllInvitationByInvitedUserResponseDTO>>("/users/invitation", id, params);
};

export interface InvitationListingFilters {
  status?: string;
  search?: string;
  fromDate?: string;
  toDate?: string;
}

/**
 * Filtered + paginated invite-link listing for one user, plus aggregate stats.
 * `userId` is the current candidate's user id.
 */
export const getInvitationsByInvitedUserFiltered = (
  userId: string,
  filters: InvitationListingFilters = {},
  page: number = 0,
  size?: number
) => {
  const params: any = {
    page,
  };

  if (filters.search) params.search = filters.search;
  if (filters.status && filters.status !== "ALL") params.status = filters.status;
  if (filters.fromDate) params.fromDate = filters.fromDate;
  if (filters.toDate) params.toDate = filters.toDate;
  if (size !== undefined) params.size = size;

  return getApiListById<PagedStatsResponse<AllInvitationByInvitedUserResponseDTO, InvitationStats>>(
    "/users/invitation",
    `${userId}/filtered`,
    params
  );
};


export const searchCandidates = (payload: any, page: number =0 ,size?: number) => {
  const params: any = {
    page,
  };    

  // Only send size if provided
  if (size !== undefined) {
    params.size = size;
  }
  return postApiPagination<PaginationResponse<CandidateProfile>>("/candidates/search", payload, params);
};




export const searchGlobalCandidates = (payload: any, page: number =0 ,size?: number) => {
  const params: any = {
    page,
  };    

  // Only send size if provided
  if (size !== undefined) {
    params.size = size;
  }
  return postApiPagination<PaginationResponse<CandidateProfile>>("/candidates/search", payload, params);
};


export const getCandidatesTotalStats = () => {
  return getApi<CandidateTotalCountResponse>("/candidates/stats");
};